import React, { Component } from 'react';
import { Col, Container, Row, Nav, NavItem, NavLink, Button, Modal } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import ItemMasterDetails from '../ItemMasterDetails/components/itemMasterDetails';
import TaxMaster from '../TaxMaster/components/taxMaster';
import UploadIcon from '../../../images/UploadIcon.svg';
//import 'font-awesome/css/font-awesome.min.css'; // FontAwesome icons

import "../../global.css";

class ItemMaster extends Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab'); // e.g., "po_list" or "po_approval"
    this.state = {
      activeTab: 'item_list',
      activeTab: tab === 'item_list' ? 'item_list' : tab === 'tax_master' ? 'tax_master' : 'item_list',
      modalOpen: false,
      file: null,
      error: '',
      success: false
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleModal = () => {
    this.setState((prevState) => ({ modalOpen: !prevState.modalOpen, file: null, error: '', success: false }));
  };

  handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];

    if (uploadedFile && uploadedFile.name.endsWith('.xls')) {
      this.setState({ file: uploadedFile, error: '', success: true });
    } else {
      this.setState({ file: null, error: 'Please upload a correct file.', success: false });
    }
  };

  removeFile = () => {
    this.setState({ file: null, error: '', success: false });
  };

  render() {
    const { t } = this.props;
    const { activeTab, modalOpen, file, error, success } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12} id="master_tab_container" className="master_tab_container">
            <Nav style={{ backgroundColor: '#fff', marginBottom: 6, paddingLeft: 0 }} tabs>
              <NavItem>
                <NavLink
                  className={activeTab === 'item_list' ? 'active1' : ''}
                  style={activeTab === 'item_list' ? { backgroundColor: '#FEF1CC', margin: 0 } : {}}
                  onClick={() => this.toggleTab('item_list')}
                >
                  Item List
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'map_tax' ? 'active1' : ''}
                  style={activeTab === 'map_tax' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                  onClick={() => this.toggleTab('map_tax')}
                >
                  Map Tax
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tax_master' ? 'active1' : ''}
                  style={activeTab === 'tax_master' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                  onClick={() => this.toggleTab('tax_master')}
                >
                  Tax Master
                </NavLink>
              </NavItem>

              {/* Bulk Upload Button */}
              {activeTab === 'item_list' && (
                <NavItem className="ml-auto">
                  <Button
                    color="warning"
                    style={{ backgroundColor: 'white', borderColor: '#FBBB00', color: '#FBBB00', marginBottom: 0 }}
                    onClick={this.toggleModal}
                  >
                    <img src={UploadIcon} alt="Upload" style={{ width: 20, height: 16, marginRight: 10 }} />
                    Bulk Upload
                  </Button>
                </NavItem>
              )}
            </Nav>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            {activeTab === 'item_list' ? <ItemMasterDetails /> : activeTab === 'map_tax' ? "" : <TaxMaster />}
          </Col>
        </Row>

        {/* Excel Upload Modal */}
        <Modal isOpen={modalOpen} toggle={this.toggleModal} centered>
          <div style={{ padding: '20px', borderTop: '5px solid #FBBB00', textAlign: 'center' }}>
            <h4 style={{ fontWeight: 'bold' }}>Bulk Upload Items</h4>

            {/* File Upload Box */}
            <div
              style={{
                border: '2px dashed #ddd',
                borderRadius: '8px',
                padding: '20px',
                backgroundColor: '#fef7e0',
                textAlign: 'center',
                marginTop: '15px',
                position: 'relative',
              }}
            >
              {file ? (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>
                    <i className="fa fa-file-excel-o" style={{ color: 'green', fontSize: '20px' }}></i>
                    &nbsp; {file.name}
                  </span>
                  <i className="fa fa-times-circle" onClick={this.removeFile} style={{ color: 'red', cursor: 'pointer' }}></i>
                </div>
              ) : (
                <>
                  <i className="fa fa-cloud-upload" style={{ fontSize: '40px', color: '#FBBB00' }}></i>
                  <p style={{ margin: '10px 0', color: '#666' }}>Upload documents in .XLS</p>
                  <label style={{ color: '#FBBB00', cursor: 'pointer', fontWeight: 'bold' }}>
                    <input type="file" accept=".xls" style={{ display: 'none' }} onChange={this.handleFileChange} />
                    Download Sample File
                  </label>
                </>
              )}
            </div>

            {/* Error Message */}
            {error && (
              <p style={{ color: 'red', fontSize: '14px', marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="fa fa-times-circle" style={{ marginRight: '5px' }}></i>
                {error}
              </p>
            )}

            {/* Success Message */}
            {success && (
              <p style={{ color: 'green', fontSize: '14px', marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="fa fa-check-circle" style={{ marginRight: '5px' }}></i>
                File is successfully uploaded
              </p>
            )}

            {/* Footer Buttons */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <Button
                onClick={this.toggleModal}
                style={{
                  backgroundColor: 'white',
                  border: '2px solid #FBBB00',
                  color: 'black',
                  padding: '10px 24px',
                  marginRight: '10px',
                  borderRadius: '5px',
                }}
              >
                Cancel
              </Button>

              <Button
                onClick={() => alert('File Uploaded')}
                disabled={!file}
                style={{
                  backgroundColor: '#FBBB00',
                  border: 'none',
                  color: 'black',
                  padding: '10px 24px',
                  borderRadius: '5px',
                }}
              >
                Upload
              </Button>
            </div>
          </div>
        </Modal>
      </Container>
    );
  }
}

ItemMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ItemMaster);
